// extracted by mini-css-extract-plugin
export default {"pageTitle":"partner_pageTitle__D+rnq","partner":"partner_partner__wRW7p"};